var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficeMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.977,
    height: 59.037,
    viewBox: "0 0 46.977 59.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_building_location_company_location_office_position_icon-1320185156686423965_0",
    "data-name": "svg+building+location+company+location+office+position+icon-1320185156686423965_0",
    transform: "translate(-22.735 -17.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M46.223,17.293a23.489,23.489,0,0,0-6.06,46.183l4.471,11.758a1.7,1.7,0,0,0,1.59,1.1h.01a1.7,1.7,0,0,0,1.586-1.116L52.1,63.526a23.49,23.49,0,0,0-5.874-46.233Z",
    fill: "#00a693"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M51.873,27.65H33.385V52.968H56.45a3.981,3.981,0,0,0,3.977-3.975V36.824H51.874V27.65ZM36.785,49.568V31.051H48.473v5.772h0V49.568Zm20.24-9.343V49a.582.582,0,0,1-.576.574H51.873V40.224Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 3.4,
    height: 2.828,
    transform: "translate(38.57 44.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3.4,
    height: 2.829,
    transform: "translate(38.57 38.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 3.4,
    height: 2.829,
    transform: "translate(38.57 33.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 3.4,
    height: 2.829,
    transform: "translate(43.285 38.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 3.4,
    height: 2.828,
    transform: "translate(43.285 44.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.4,
    height: 2.829,
    transform: "translate(43.285 33.289)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeMarker);
export default __webpack_public_path__ + "static/media/office-marker.fca0accb63c9a9964b5d0ebc95bd3e2a.svg";
export { ForwardRef as ReactComponent };